import apiClient from "./axios";

export const getBrtaCodes = async (params = {}) => {
  const { data } = await apiClient.get("/brta-codes", { params });
  return data;
};

export const createBrtaCode = async payload => {
  const { data } = await apiClient.post("/brta-codes", payload);
  return data;
};

export const editBrtaCode = async ({ id, ...payload }) => {
  const { data } = await apiClient.patch(`/brta-codes/${id}`, payload);
  return data;
};

export const deleteBrtaCode = async id => {
  const { data } = await apiClient.delete(`/brta-codes/${id}`);
  return data;
};
